<template>
  <div style="display: none" />
</template>

<script>
import axios from 'axios'

export default {
  name: 'NewVersionNotification',
  data () {
    return {
      currentPage: null,
      interval: null,
      warning: null,
      time: 30,
      updateToasterId: 'new-version-notification'
    }
  },
  computed: {
    onLoginPage () {
      return this.$route.name === 'Login'
    },
    countdownText () {
      return this.$t('Common.hasAvailableUpdate', { time: this.time })
    }
  },
  async mounted () {
    if (process.env.VUE_APP_ENV_VERSION !== 'undefined') this.currentPage = await this.fetchData()
    if (this.currentPage) this.startTimer()
  },
  beforeDestroy () {
    this.makeClearInterval()
  },
  methods: {
    async fetchData () {
      const response = await axios.get('/', {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: 0
        }
      })

      if (!response) return false
      return response
    },
    showUpdatePopup () {
      if (this.onLoginPage) return window.location.reload()

      this.$buefy.snackbar.open({
        duration: 30000,
        message: `<span id="${this.updateToasterId}">${this.countdownText}</span>`,
        type: 'is-success',
        position: 'is-top',
        actionText: this.$t('Common.update'),
        onAction: this.doUpdate
      })

      this.warning = this.getNotificationObject()
      this.$nextTick(() => this.startTimeout())
    },
    doUpdate () {
      if (this.onLoginPage) return window.location.reload()

      this.$router.push({ name: 'Login' }, () => {
        window.location.reload()
      })

      this.startTimer()
    },
    startTimer () {
      const timeToCheck = 10 * 60 * 1000 // 10mins

      this.interval = setInterval(async () => {
        const newPage = await this.fetchData()
        if (newPage && newPage.data && newPage.data !== this.currentPage.data) {
          this.makeClearInterval()
          this.showUpdatePopup()
        }
      }, timeToCheck)
    },
    startTimeout () {
      const timeout = setInterval(() => {
        this.time--

        if (this.time === 0) {
          clearInterval(timeout)
          return this.doUpdate()
        }

        // check if we successfully selected the opened notification
        if (this.warning) this.warning.textContent = this.countdownText
        else this.warning = this.getNotificationObject()
      }, 1000)
    },
    makeClearInterval () {
      clearInterval(this.interval)
      this.interval = null
    },
    getNotificationObject () {
      return document.querySelector(`#${this.updateToasterId}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewVersionNotification.vue